export default function formatEventDashboardDateTime(isoString) {
  if (!isoString) {
    return "";
  }

  const date = new Date(isoString);
  const datePart = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }).format(date);
  const timePart = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZoneName: "short"
  }).format(date);

  return `${datePart} ${timePart}`;
}
